import { Icon } from "@components/icon";
import { LinkWithConfirm } from "@components/link_with_confirm/link_with_confirm";
import * as types from "@root/types";
import { isEmpty } from "@services/helpers";
import { isNil, truncate } from "@services/typed_helpers";
import cx from "classnames";
import React, { type FC } from "react";

interface StudioEventsListProps {
  studioEvents: types.StudioEventModel[] | undefined;
}
const StudioEventRow: FC<{ studioEvent: types.StudioEventModel }> = ({
  studioEvent,
}) => {
  const deleteLink = (
    <LinkWithConfirm
      className="delete_link"
      confirmMessage="Are you sure you want to delete this content block?"
      href={`/admin/studio_events/${studioEvent.slug}/delete`}
      title="Delete event"
    >
      <Icon name="bin2" />
    </LinkWithConfirm>
  );

  const editLink = (
    <a
      href={`/admin/studio_events/${studioEvent.slug}/edit`}
      title="Edit event"
    >
      <Icon name="pencil" />
    </a>
  );

  const previewLink = (
    <a href={`/?preview=${studioEvent.slug}`} title="Preview event">
      <Icon name="flash_on" />
    </a>
  );

  return (
    <tr>
      <td className="headline">
        <a href={`/events/${studioEvent.slug}`} target="_blank">
          {studioEvent.headline}
        </a>
      </td>
      <td className="body">{truncate(studioEvent.description)}</td>
      <td className="banner-image">
        <img className="thumbnail" src={studioEvent.bannerImageUrl} />
      </td>
      <td className="display-image">
        <img className="thumbnail" src={studioEvent.displayImageUrl} />
      </td>
      <td className="start-date table-cell--date">{studioEvent.startDate}</td>
      <td className="activate-date table-cell--date">
        {studioEvent.activateDate}
      </td>
      <td className="deactivate-date table-cell--date">
        {studioEvent.deactivateDate}
      </td>
      <td className="published">
        {studioEvent.isPublished && <Icon name="checkmark" />}
      </td>
      <td className="ctrls">
        <div className="actions">
          {previewLink}
          {editLink}
          {deleteLink}
        </div>
      </td>
    </tr>
  );
};

const StudioEventsList: FC<StudioEventsListProps> = ({ studioEvents }) => {
  return (
    <table className={cx("studio_events", "striped", "admin-table")}>
      <thead>
        <tr>
          <th scope="col">Headline</th>
          <th scope="col">Description</th>
          <th scope="col">Banner Image</th>
          <th scope="col">Display Image</th>
          <th scope="col">Start Date</th>
          <th scope="col">Activate on</th>
          <th scope="col">Deactivate on</th>
          <th scope="col">Published</th>
          <th className="ctrls" scope="col"></th>
        </tr>
      </thead>
      <tbody>
        {isNil(studioEvents) || isEmpty(studioEvents) ? (
          <tr>
            <td colSpan={8}>You've got no studio events!</td>
          </tr>
        ) : (
          studioEvents.map((studioEvent) => (
            <StudioEventRow studioEvent={studioEvent} key={studioEvent.id} />
          ))
        )}
      </tbody>
    </table>
  );
};

export { StudioEventsList };
